import styled from "@emotion/styled"

const NakedButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  color: inherit;
  display: inline-block;
  font: inherit;
  padding: initial;
  cursor: pointer;
`
export default NakedButton
